import React from 'react';
import isEmailValid from '../utils/email-validation';

const EmailInput = ({
  email,
  setEmail,
  classNames,
  id,
  ariaDescribedby,
  error,
  setError,
  isBlurred,
  setIsBlurred,
  EmailPlaceholder,
  EmailErrorMessage,
}) => {
  const validateEmail = () => {
    const emailIsValid = isEmailValid(email);
    if (!emailIsValid && email) {
      setError(EmailErrorMessage || 'Please enter a valid email address.');
    } else {
      setError('');
    }
  };

  const handleBlur = () => {
    setIsBlurred(true);
    validateEmail();
  };

  return (
    <div>
      <input
        // eslint-disable-next-line max-len
        className={`body-2 ${classNames} w-full rounded-[30px] border border-solid border-default px-6 py-3 placeholder:text-default focus:border-default focus:outline-none focus:ring-2 focus:ring-default`}
        type="email"
        name="email"
        id={id}
        placeholder={EmailPlaceholder || 'enter email address'}
        value={email}
        onBlur={handleBlur}
        onChange={(e) => setEmail(e.target.value)}
        aria-describedby={ariaDescribedby}
        required
      />
      {isBlurred && error !== '' && (
        <p
          id="emailHelp"
          className="body-3 mt-1 pl-6 text-error"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default EmailInput;
